import { render, staticRenderFns } from "./XydContractGroup.vue?vue&type=template&id=f84d4fb2&scoped=true"
import script from "./XydContractGroup.vue?vue&type=script&lang=js"
export * from "./XydContractGroup.vue?vue&type=script&lang=js"
import style0 from "./XydContractGroup.vue?vue&type=style&index=0&id=f84d4fb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84d4fb2",
  null
  
)

export default component.exports